import { IComponentController, IComponentOptions } from 'angular';

import templateUrl from './agent-booking-mail-inprocess-knowledge.component.ajs.html';

const MODULE_NAME = 'agentBookingMailInprocessKnowledge';

class AgentBookingMailInprocessKnowledgeCtrl implements IComponentController {
  public name = MODULE_NAME;

  responseId: string;

  $onInit() {}
}

export class AgentBookingMailInprocessKnowledge implements IComponentOptions {
  templateUrl = templateUrl;
  bindings = {
    responseId: '<',
  } as { [binding: string]: string };
  controller = [AgentBookingMailInprocessKnowledgeCtrl];
}

export default MODULE_NAME;
